import React from "react";
import { ArtifactVizType } from "../utils";
import { Skeleton } from "./ui/skeleton";

interface ArtifactSkeletonProps {
    type: ArtifactVizType;
}

// Widths and heights below are data (one per bar or column), so they stay inline styles.

const TableSkeleton: React.FC = () => (
    <div className="chat-v2-artifact-skeleton-table">
        <div className="chat-v2-artifact-skeleton-row">
            {[40, 60, 50, 55].map((w, i) => (
                <Skeleton key={i} className="h-3.5 rounded" style={{ width: w }} />
            ))}
        </div>
        {[0, 1, 2, 3, 4].map((row) => (
            <div key={row} className="chat-v2-artifact-skeleton-row">
                {[90, 50, 50, 55].map((w, i) => (
                    <Skeleton key={i} className="h-3 rounded" style={{ width: w }} />
                ))}
            </div>
        ))}
    </div>
);

const ChartSkeleton: React.FC = () => (
    <div className="chat-v2-artifact-skeleton-chart">
        {[33, 48, 24, 57, 39, 45, 30, 51, 36].map((h, i) => (
            <Skeleton key={i} className="w-5 rounded" style={{ height: h }} />
        ))}
    </div>
);

const StatCardSkeleton: React.FC = () => (
    <div className="chat-v2-artifact-skeleton-stat flex gap-4">
        <Skeleton className="size-8 shrink-0 rounded-full" />
        <div className="flex flex-1 flex-col gap-3">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/5" />
        </div>
    </div>
);

const InsightsSkeleton: React.FC = () => (
    <div className="chat-v2-artifact-skeleton-insights">
        {[0, 1, 2].map((i) => (
            <div key={i} className="chat-v2-insight-item">
                <div className="flex gap-4">
                    <Skeleton className="size-6 shrink-0 rounded-full" />
                    <div className="flex flex-1 flex-col gap-3">
                        <Skeleton className="h-4 w-[55%]" />
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-3/5" />
                    </div>
                </div>
            </div>
        ))}
    </div>
);

const ArtifactSkeleton: React.FC<ArtifactSkeletonProps> = ({ type }) => {
    if (type === "table") return <TableSkeleton />;
    if (type === "chart") return <ChartSkeleton />;
    if (type === "stat_card") return <StatCardSkeleton />;
    if (type === "insights") return <InsightsSkeleton />;
    return null;
};

export default ArtifactSkeleton;
